export default __webpack_public_path__ + "static/media/zip-large.d09b9594.svg";